var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"cr-loading"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","size":"48"}}),_c('p',{staticClass:"mt-4"},[_vm._v("AI Content Generation Initialising...")]),_c('v-icon',[_vm._v("mdi-memory")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }